import { useEffect, useContext, useRef } from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { useUser } from '@luigiclaudio/ga-auth-theme';
import { ModalContext } from '@luigiclaudio/ga-baseline-ui/modal';
import ColorToolsContext from './context/ColorToolsContext';
import AddColorModal from './addColorModals/AddColorModal';
import { readLibrarySignupContext, clearLibrarySignupContext } from '../utils/librarySignupContext';

// Registration is never reported as a save. Restore the original tool and ask
// for explicit confirmation using the existing save modal.
const LibrarySaveReturn = () => {
    const { pathname } = useLocation();
    const { userFromClient, setUserFromClient, setAllColorsUserFromClient, setSelectedColors } =
        useContext(ColorToolsContext);
    const { showModal } = useContext(ModalContext);
    const [user] = useUser();
    const previousIdentity = useRef(user?.id);
    useEffect(() => {
        if (previousIdentity.current !== user?.id) {
            previousIdentity.current = user?.id;
            setUserFromClient(undefined);
            setAllColorsUserFromClient(undefined);
            setSelectedColors([]);
        }
    }, [user?.id]);
    useEffect(() => {
        const intent = readLibrarySignupContext();
        if (
            user?.id === userFromClient?.netlifyId &&
            userFromClient?.accountReady &&
            intent?.pendingColor &&
            pathname === intent.returnTo
        ) {
            clearLibrarySignupContext();
            showModal(AddColorModal, { colorValue: intent.pendingColor });
        }
    }, [pathname, userFromClient, user, showModal]);
    return null;
};

export default LibrarySaveReturn;
